import * as Sentry from "@sentry/react"

type PreviewWindow = Window &
  typeof globalThis & {
    PermutWidget?: { destroy?: () => void }
    __PERMUT_WIDGET_INSTANCES__?: Record<string, { destroy?: () => void }>
    __PERMUT_PREVIEW_CONFIG__?: unknown
  }

export const resetPreviewWidget = (iframe: HTMLIFrameElement, feature: string) => {
  const win = iframe.contentWindow as PreviewWindow | null
  if (!win) return

  const instances = new Set([
    ...Object.values(win.__PERMUT_WIDGET_INSTANCES__ ?? {}),
    win.PermutWidget,
  ])

  instances.forEach((instance) => {
    try {
      instance?.destroy?.()
    } catch (error) {
      Sentry.captureException(error, {
        tags: { feature },
        extra: { message: "Error destroying widget preview instance" },
      })
    }
  })

  win.__PERMUT_WIDGET_INSTANCES__ = {}
  delete win.__PERMUT_PREVIEW_CONFIG__
}
